import { pushToDataLayer } from 'utils/analytics';

export const initGlobalErrorHandlers = (): void => {
  window.onerror = (message, source, lineno, colno, error) => {
    pushToDataLayer({
      event: 'ui_error',
      event_time: new Date().toISOString(),
      error_message: typeof message === 'string' ? message : 'Unknown error',
      error_source: 'window_onerror',
      error_stack: error?.stack,
    });
  };

  window.addEventListener(
    'unhandledrejection',
    (event: PromiseRejectionEvent) => {
      const error = event.reason;

      pushToDataLayer({
        event: 'ui_error',
        event_time: new Date().toISOString(),
        error_message: error instanceof Error ? error.message : String(error),
        error_source: 'unhandled_rejection',
        error_stack: error instanceof Error ? error.stack : undefined,
      });
    },
  );
};
